module.exports = __webpack_public_path__ + "img/hygiene2.4badc5e7.jpg";